// Type definitions for custom accommodation

// Define FormData type
export interface FormData {
  name: string;
  location: LocationInput;
  pricePerNight: string;
  priceType: "perNight" | "total";
  totalPrice: string;
  numNights: string;
  numGuests: string;
  checkInTime: string; // ISO string
  checkOutTime: string; // ISO string
  amenities: string[];
  images: Array<{
    file: File; // Using the browser's built-in File type
    preview: string;
    url?: string;
  }>;
}

export type LocationInput = {
  type: "address" | "pin";
  value: string;
  coordinates: { latitude: number; longitude: number };
};

export type Question = {
  id: keyof FormData;
  question: string;
  placeholder: string;
  type:
    | "input"
    | "textarea"
    | "images"
    | "amenities"
    | "time"
    | "location"
    | "price";
  inputType?: "text" | "number" | "email" | "tel" | "url" | "password";
  prefix?: string;
  suffix?: string;
};

export const amenityOptions = [
  "WiFi",
  "Pool",
  "Gym",
  "Parking",
  "Kitchen",
  "Air Conditioning",
  "Heating",
  "TV",
  "Washer",
  "Dryer",
  "Workspace",
  "Pet Friendly",
];
